import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey"; // Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { compactFromU8a, compactToU8a, isBigInt, isBn, isNumber, isString } from '@polkadot/util';
import { typeToConstructor } from "./utils/index.mjs";
/**
 * @name Compact
 * @description
 * A compact length-encoding codec wrapper. It performs the same function as Length, however
 * differs in that it uses a variable number of bytes to do the actual encoding. This is mostly
 * used by other types to add length-prefixed encoding, or in the case of wrapped types, taking
 * a number and making the compact representation thereof
 */

var _Type = _classPrivateFieldLooseKey("Type");

var _raw = _classPrivateFieldLooseKey("raw");

export var Compact =
/*#__PURE__*/
function () {
  function Compact(registry, Type) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, Compact);

    this.registry = void 0;
    Object.defineProperty(this, _Type, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _raw, {
      writable: true,
      value: void 0
    });
    this.registry = registry;
    _classPrivateFieldLooseBase(this, _Type)[_Type] = typeToConstructor(registry, Type);
    _classPrivateFieldLooseBase(this, _raw)[_raw] = Compact.decodeCompact(registry, _classPrivateFieldLooseBase(this, _Type)[_Type], value);
  }

  _createClass(Compact, [{
    key: "bitLength",

    /**
     * @description Returns the number of bits in the value
     */
    value: function bitLength() {
      return _classPrivateFieldLooseBase(this, _raw)[_raw].bitLength();
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */

  }, {
    key: "eq",
    value: function eq(other) {
      return _classPrivateFieldLooseBase(this, _raw)[_raw].eq(other instanceof Compact ? _classPrivateFieldLooseBase(other, _raw)[_raw] : other);
    }
    /**
     * @description Returns a BigInt representation of the number
     */

  }, {
    key: "toBigInt",
    value: function toBigInt() {
      return BigInt(this.toString());
    }
    /**
     * @description Returns the BN representation of the number
     */

  }, {
    key: "toBn",
    value: function toBn() {
      return _classPrivateFieldLooseBase(this, _raw)[_raw].toBn();
    }
    /**
     * @description Returns a hex string representation of the value. isLe returns a LE (number-only) representation
     */

  }, {
    key: "toHex",
    value: function toHex(isLe) {
      return _classPrivateFieldLooseBase(this, _raw)[_raw].toHex(isLe);
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman(isExtended) {
      return _classPrivateFieldLooseBase(this, _raw)[_raw].toHuman(isExtended);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return _classPrivateFieldLooseBase(this, _raw)[_raw].toJSON();
    }
    /**
     * @description Returns the number representation for the value
     */

  }, {
    key: "toNumber",
    value: function toNumber() {
      return _classPrivateFieldLooseBase(this, _raw)[_raw].toNumber();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return "Compact<".concat(this.registry.getClassName(_classPrivateFieldLooseBase(this, _Type)[_Type]) || _classPrivateFieldLooseBase(this, _raw)[_raw].toRawType(), ">");
    }
    /**
     * @description Returns the string representation of the value
     */

  }, {
    key: "toString",
    value: function toString() {
      return _classPrivateFieldLooseBase(this, _raw)[_raw].toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      return compactToU8a(_classPrivateFieldLooseBase(this, _raw)[_raw].toBn());
    }
    /**
     * @description Returns the embedded [[UInt]] or [[Moment]] value
     */

  }, {
    key: "unwrap",
    value: function unwrap() {
      return _classPrivateFieldLooseBase(this, _raw)[_raw];
    }
  }, {
    key: "encodedLength",

    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get: function get() {
      return this.toU8a().length;
    }
    /**
     * @description returns a hash of the contents
     */

  }, {
    key: "hash",
    get: function get() {
      return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _raw)[_raw].isEmpty;
    }
  }], [{
    key: "with",
    value: function _with(Type) {
      return (
        /*#__PURE__*/
        function (_Compact) {
          _inherits(_class, _Compact);

          function _class(registry, value) {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, registry, Type, value));
          }

          return _class;
        }(Compact)
      );
    }
    /** @internal */

  }, {
    key: "decodeCompact",
    value: function decodeCompact(registry, Type, value) {
      if (value instanceof Compact) {
        return new Type(registry, _classPrivateFieldLooseBase(value, _raw)[_raw]);
      } else if (isString(value) || isNumber(value) || isBn(value) || isBigInt(value)) {
        return new Type(registry, value);
      }

      var _compactFromU8a = compactFromU8a(value, new Type(registry, 0).bitLength()),
          _compactFromU8a2 = _slicedToArray(_compactFromU8a, 2),
          _value = _compactFromU8a2[1];

      return new Type(registry, _value);
    }
  }]);

  return Compact;
}();